/**
 * Parses PW Plugin version string into a numerical representation which can be
 * used to compare feature sets.
 * @param versionString PW Plugin version string
 * @returns Numerical representation of the version string
 */
export function numericalPwPluginVersion(versionString) {
    const versionParts = versionString === null || versionString === void 0 ? void 0 : versionString.split('.');
    if ((versionParts === null || versionParts === void 0 ? void 0 : versionParts.length) != 4 ||
        versionParts.some((part) => isNaN(Number(part)))) {
        console.error('Invalid version string:', versionString);
        return 3.0;
    }
    const [year, major, minor, patch] = versionParts.map(Number);
    // Version standards changed after major version 10.
    // We now use YY.aa.bb.cc (Year.major.minor.patch)
    // This will return a larger value, still as a number
    // ex. '23.06.03.12' will become 230603.12
    if (year >= 23) {
        const majorString = String(major).padStart(2, '0');
        const minorString = String(minor).padStart(2, '0');
        return Number(`${year}${majorString}${minorString}.${patch}`);
    }
    // Older formats followed a format of
    // 10.03.mm.pp, always starting with 10.03
    if (year >= 10 && major >= 0 && minor >= 3) {
        return Number(`${minor}.${patch}`);
    }
    // Even older formats (major version 3) use the format of
    // 10.00.03.pp, always starting with 10.00.03
    return 3.0;
}
/**
 * Determines if the provided PW Plugin version is considered legacy.
 * @param pluginVersion PW Plugin version string
 * @returns True if the version is considered legacy (less than 3.4)
 */
export function isLegacyPwPlugin(pluginVersion) {
    return numericalPwPluginVersion(pluginVersion) < 3.4;
}
